import { Injectable, EventEmitter, Inject, isDevMode } from '@angular/core';
import { Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';

import { TokenHttp } from '../services/tokenhttp.service';
import { BootConstants } from '../boot.constants';
import { IChangePassword } from '../interfaces/IChangePassword';
import { map } from 'rxjs/operators';
import { BaseRepository } from './base.repository';
import { IDepositListFilter } from '../interfaces/IDepositListFilter';
import { IPlantToDepotTour } from '../interfaces/ITour';
import { IPlantToDepotDetails } from '../interfaces/IPlantToDepotDetails';


@Injectable()
export class CarrierTourRepository extends BaseRepository {

    constructor(tokenHttp: TokenHttp) {
        super(tokenHttp);
    }

    public plantToDepotList(filter: IDepositListFilter): Observable<IPlantToDepotTour[]> {
        return this.mapGet("carrier/tours/plantToDepot/list", filter);
    }

    public plantToDepotDetails(id: string): Observable<IPlantToDepotDetails> {
        return this.mapGet("carrier/tours/plantToDepot/" + id + "/details");
    }

    public plantToDepotApprove(id: string): Observable<IPlantToDepotDetails> {
        return this.mapPut("carrier/tours/plantToDepot/" + id + "/approve");
    }


}
